import { Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles<Theme, {}>((theme) => ({
  root: {
    margin: "1rem 3rem",
    paddingRight: "1.5rem",
  },

  title: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: theme.size.sm,
    marginBottom: "1rem",
    alignItems: "flex-start",
  },

  items: {
    width: "100%",
    textAlign: "center",
    cursor: "default",
  },
}));

export default useStyles;
